/** @format */

import React, { useEffect, useState } from 'react';
import { makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, withStyles } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { configDefault } from '../../core/config';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import { FilterReducerFieldName } from '../../modules/filter/FilterReducers';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import Pager from '../../components/Adescom/Pager';
import EditButton from '../../components/Buttons/EditButton';
import { history } from '../../core/history';
import { serviceCodeConstants, serviceCodeReducerType } from '../../modules/servicecode/reducers';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import HistoryButton from '../../components/Buttons/HistoryButton';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import { ServiceCodeCollectionInterface } from '../../interfaces/collections/ServiceCodeCollectionInterface';
import ServiceCode from '../../interfaces/platform/ServiceCode';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import PaperedTable from '../../components/Table/PaperedTable';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';

const ServiceCodeList = (props: { classes: any }): React.ReactElement => {
    const dispatch = useDispatch();
    const [filters, setFilters] = useState<Array<Filter>>([]);
    const [orders, setOrders] = useState<Array<Order>>([]);

    const { collections } = useSelector((state: { serviceCodeReducers: serviceCodeReducerType }) => {
        return state.serviceCodeReducers;
    });
    const tableCellRoot = { root: props.classes.tableCellRoot };
    const tableStickyHeader = { root: props.classes.tableStickyHeader };
    const tableRowRoot = { root: props.classes.tableRowRoot };
    const tableStickyCommand = { root: props.classes.tableStickyCommand };

    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/service_codes', configDefault.PLATFORM_API_PREFIX)),
            serviceCodeConstants.SERVICE_CODE_LIST,
            [],
            [{ name: 'text', value: 'desc' }],
            (data: ServiceCodeCollectionInterface) => {
                dispatch({
                    type: serviceCodeConstants.SERVICE_CODE_LIST,
                    collections: data,
                });
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    }, [dispatch]);

    const updateOrderList = (orders: Array<Order>): void => {
        setOrders(orders);
    };
    const updateFilterList = (filters: Array<Filter>): void => {
        setFilters(filters);
    };

    const paginationCallbackFunction = (uri: string | null = null): void => {
        if (!uri || !Object.keys(uri).length) {
            uri = FormGeneralHelper.getPath('/service_codes', configDefault.PLATFORM_API_PREFIX);
        }
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(uri),
            serviceCodeConstants.SERVICE_CODE_LIST,
            filters,
            orders,
            (data: ServiceCodeCollectionInterface) => {
                dispatch({
                    type: serviceCodeConstants.SERVICE_CODE_LIST,
                    collections: data,
                });
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    };

    const clearFilter = (): void => {
        setFilters([]);
        setOrders([{ name: 'text', value: 'desc' }]);

        dispatch({
            type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            clearAll: true,
        });
        dispatch({
            type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
        });
    };

    const editServiceCode = (param: { id: number; serviceCodeName: string; serviceCodeDescription: string | null; platformResellerId: number; history: boolean }): void => {
        const redirectUri = FormGeneralHelper.getRouteUrl('/service-code-edit/' + param.id);

        history.push(redirectUri, {
            serviceCodeName: param.serviceCodeName,
            serviceCodeDescription: param.serviceCodeDescription,
            serviceCodePlatformResellerId: param.platformResellerId,
            history: param.history,
        });
    };

    const addServicCode = (): void => {
        const redirectUri = FormGeneralHelper.getRouteUrl('/service-code-add/');

        history.push(redirectUri);
    };

    const showHistory = (param: { id: number; history: boolean; serviceCodeName: string; serviceCodeDescription: string; platformResellerId: number }): void => {
        const redirectUri = FormGeneralHelper.getRouteUrl('/service-code-edit/' + param.id);

        history.push(redirectUri, {
            history: param.history,
            serviceCodeName: param.serviceCodeName,
            serviceCodeDescription: param.serviceCodeDescription,
            serviceCodePlatformResellerId: param.platformResellerId,
        });
    };
    return (
        <GridContainer>
            <GridItem xs={12} style={{ marginBottom: 20 }}>
                <CustomTextButtom
                    size={'lg'}
                    callback={addServicCode}
                    callbackParam={{}}
                    color="primary"
                    label="service_code:b.add_new_service_code"
                />
            </GridItem>
            <GridItem xs={12}>
                <PaperedTable
                    beforeTableContent={
                        <GridContainer>
                            <GridItem xs={12}>
                                {(filters.length > 0 || orders.length > 0) && (
                                    <>
                                        <CustomTextButtom
                                            size={'lg'}
                                            callback={paginationCallbackFunction}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.search"
                                        />
                                        <CustomTextButtom
                                            size={'lg'}
                                            callback={clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear_filter"
                                        />
                                    </>
                                )}
                            </GridItem>
                        </GridContainer>
                    }
                >
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyCommand} padding="none" align="left">
                                <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    textAlign={'left'}
                                    title="service_code:h.service_code_name"
                                    fieldName="text"
                                    showSort={true}
                                    onlyFilter={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={paginationCallbackFunction}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    title="prov:list.partner"
                                    textAlign="left"
                                    fieldName="platformResellerId"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="select"
                                    selectComponent="headerPlatformReseller"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={paginationCallbackFunction}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collections && collections['hydra:member'] && collections['hydra:member'].length > 0 &&
                            collections['hydra:member'].map((el: ServiceCode) => {
                                return (
                                    <TableRow key={el.id} classes={tableRowRoot}>
                                        <TableCell classes={tableCellRoot}>
                                            <EditButton
                                                tooltipTitle={'service_code:tt.edit_service_code'}
                                                callback={editServiceCode}
                                                callbackParam={{
                                                    id: el.id,
                                                    serviceCodeName: el.text,
                                                    serviceCodeDescription: el.description,
                                                    platformResellerId: el.platformResellerId,
                                                    history: false,
                                                }}
                                            />
                                            <HistoryButton
                                                tooltipTitle={'service_code:tt.show_service_code_history'}
                                                callback={showHistory}
                                                callbackParam={{
                                                    id: el.id,
                                                    history: true,
                                                    serviceCodeName: el.text,
                                                    serviceCodeDescription: el.description,
                                                    platformResellerId: el.platformResellerId,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell classes={tableCellRoot}>{el.text}</TableCell>
                                        <TableCell classes={tableCellRoot}>{el.platformResellerName}</TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={2}>
                                {collections && collections['hydra:view'] && (
                                    <Pager callback={paginationCallbackFunction} views={collections['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </PaperedTable>
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(ServiceCodeList);
